import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React from 'react';
import Box from '../Box';
import Heading from '../Heading';
import StackView from '../StackView';

/**
 * Use for brief content that could have an accompanying image or title.
 */
function Summary(_ref) {
  var children = _ref.children,
      image = _ref.image,
      title = _ref.title,
      restProps = _objectWithoutPropertiesLoose(_ref, ["children", "image", "title"]);

  return /*#__PURE__*/React.createElement(StackView, _extends({
    alignment: "center",
    padding: 2,
    spacing: 2
  }, restProps), image && /*#__PURE__*/React.createElement(Box, null, image), title && /*#__PURE__*/React.createElement(Heading, {
    level: 3
  }, title), children && /*#__PURE__*/React.createElement(Box, {
    maxWidth: 40,
    textAlign: "center"
  }, children));
}

export default Summary;